import { SVGFC } from '@repo/toolkit/types'

const FolderIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15969_25905)">
        <path
          d="M7.125 7.625H4.5C4.20163 7.625 3.91548 7.74353 3.7045 7.9545C3.49353 8.16548 3.375 8.45163 3.375 8.75V19.25C3.37614 19.3915 3.40413 19.5315 3.4575 19.6625M18.375 11.375V10.25C18.375 9.95163 18.2565 9.66548 18.0455 9.4545C17.8345 9.24353 17.5484 9.125 17.25 9.125H16.875"
          stroke={color}
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.45703 19.6695C3.54075 19.8776 3.68472 20.0558 3.87048 20.1814C4.05623 20.3071 4.27529 20.3743 4.49953 20.3745H17.2495C17.5001 20.3735 17.7432 20.2888 17.9402 20.1339C18.1372 19.979 18.2769 19.7628 18.337 19.5195"
          stroke={color}
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3445 19.52L20.5945 12.845C20.6225 12.7323 20.6326 12.6159 20.6245 12.5C20.6245 12.2016 20.506 11.9155 20.295 11.7045C20.084 11.4935 19.7979 11.375 19.4995 11.375H6.74953C6.49459 11.3756 6.2474 11.4627 6.04845 11.6221C5.84951 11.7815 5.71062 12.0038 5.65453 12.2525L3.45703 19.67"
          stroke={color}
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.875 11.375V7.625L13.875 4.625H8.25C7.95163 4.625 7.66548 4.74353 7.4545 4.9545C7.24353 5.16548 7.125 5.45163 7.125 5.75V11.375H16.875Z"
          stroke={color}
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.875 4.625V6.5C13.875 6.79837 13.9935 7.08452 14.2045 7.2955C14.4155 7.50647 14.7016 7.625 15 7.625H16.875"
          stroke={color}
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15969_25905">
          <rect width="18" height="18" fill="white" transform="translate(3 3.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FolderIcon
